// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__FLy6c","search":"Search_search__2A3RF","icon":"Search_icon__ZzJde","transparent":"Search_transparent__13kkI"};